<template>
  <div :class="classes">
    <label :class="classesLabel">{{label}} </label>
    <div class="input-group__input">
    <v-layout row wrap>
    <template v-for="item in filteredItems">
    <div><v-tooltip bottom open-delay="500" max-width="20em">
    <div slot="activator">
    <v-chip
      :key = getKey(item)
      :tabindex="tabindex"
      small
      :text-color="errorItemMessage(item) ? 'error' : 'black'"
      @click="addItem(item)"
      @keydown.enter="addItem(item)"
      :close="!disabled"
      @input="removeItem(item)"
      @focus="onFocus()"
      @blur="onBlur()"
      >
      <v-avatar v-if="getImg(item)">
        <img :src="getImg(item)" alt="">
      </v-avatar>
      <span v-if="getText(item)" class="text-xs-center">
        {{getText(item)}}
      </span>
    </v-chip>
      </div>
      <span style="overflow-wrap: break-word">{{getHint(item)}}</span>
      <div class="error" light>{{errorItemMessage(item)}}</div>
    </v-tooltip></div>
    </template>
    <v-chip
        small
        :tabindex="tabindex"
        text-color="secondary"
        @click="addItem()"
        @keydown.enter="addItem()"
        v-show="emptyAlways || isEmpty"
        :disabled="!emptyEnabled && disabled"
        @focus="onFocus()"
        @blur="onBlur()"
        >
        <span class="text-xs-center">
        {{this.emptyChip}}
        </span>
    </v-chip>
  </v-layout>
  </div>
  <div v-if="hint" class="input-group__details"><div class="input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message">{{hint}}</div></div></div>
</div>
</template>

<script>
  import formats from '../../api/formats.js'
  export default {
    name: 'v-chips-field',
    props: {
      chipSize: {
        type: Number,
        default: 10
      },
      solo: {
        type: Boolean,
        default: false
      },
      flat: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: null,
      emptyChip: {
        type: String,
        default: null
      },
      emptyAlways: {
        type: Boolean,
        default: false
      },
      emptyEnabled: {
        type: Boolean,
        default: false
      },
      hint: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      tabindex: 0,
      items: {
        type: Array,
        default: function () {
          return []
        }
      },
      default () {
        return []
      }
    },
    data: function () {
      return {
        focused: false,
        isDirty: false,
        selected: []
      }
    },
    mounted () {
      this.$emit('change', this.value)
      this.onSetItems(this.items)
    },
    watch: {
      value: function (newVal, oldVal) { // watch it
        // this.setSelected(newVal)
        this.$emit('change', newVal)
      },
      items: function (newVal, oldVal) {
        this.onSetItems(this.items)
      }
    },
    computed: {
      classes () {
        return {
          // '.pa-0': this.solo,
          'input-group--solo': this.solo,
          'elevation-0': this.flat,
          'input-group': true,
          'input-group--text-field': true,
          'primary--text': this.focused,
          'input-group--focused': this.focused,
          'input-group--dirty': this.isDirty,
          'input-group--tab-focused': true
        }
      },
      classesLabel () {
        return {
          'caption': true,
          'v-label': true,
          'theme--light': !this.focused
        }
      },
      filteredItems () {
        let set = new Set(this.selected)
        return this.items.filter(item => set.has(this.getKey(item)))
      },
      isEmpty () {
        return this.emptyChip && this.filteredItems.length === 0
      }
    },
    methods: {
      onSetItems (items) {
        let set = new Set()
        if (items && Array.isArray(items)) {
          items.forEach(i => set.add(this.getKey(i)))
        }
        this.selected = Array.from(set)
        this.isDirty = this.emptyChip || this.selected.length > 0
      },
      getKey (item) {
        return item && (item.value || Object.values(item)[0])
      },
      getText (item) {
        let v = item && (item.text || (!item.img && this.getKey(item)) || '')
        return v.slice(0, this.chipSize)
      },
      getHint (item) {
        return item && (item.hint || this.getText(item) || this.getKey(item))
      },
      getImg (item) {
        return item && item.img
      },
      createComp (template) {
        return formats.createComp(`<span>${template}</span>`)
      },
      errorItemMessage (item) {
        return item && item.error || null
      },
      onFocus () {
        this.focused = true
      },
      onBlur () {
        this.focused = false
      },
      addItem (item) {
        if (!item) {
          if (this.emptyEnabled || !this.disabled) {
            this.$emit('click', item ? this.getKey(item) : null)
            return
          }
        }
        if (!(this.disabled && this.isEmpty)) {
          this.$emit('click', item ? this.getKey(item) : null)
        }
      },
      removeItem (item) {
        if (!(this.disabled && this.isEmpty)) {
          this.$emit('remove', item ? this.getKey(item) : null)
        }
      }
    }
  }
</script>
<!-- <style>
.input-group__input {
  background-color: blue;
}
</style> -->



// WEBPACK FOOTER //
// ChipsField.vue?ac3eb6f2